import { FC } from 'react';
import { Person } from '@clds/icon';
import { Avatar } from '@clds/avatar';
import { UserInfo } from '@cld/application-wrapper-common';
import { UserAvatarProps } from './UserAvatar.types';

const firstCharacter = (i?: string) => (i && /\b\w/.exec(i)?.[0]) || '';

const getUserNameInitials = (userInfo?: UserInfo) => {
  return (firstCharacter(userInfo?.firstName) + firstCharacter(userInfo?.lastName)).toUpperCase();
};

export const UserAvatar: FC<UserAvatarProps> = ({ userInfo }) => (
  <Avatar data-test-specifier="user-avatar" size="sm" backgroundColor={userInfo?.backgroundColor} textColor={userInfo?.textColor}>
    {userInfo ? getUserNameInitials(userInfo) : <Person data-testid="person-icon" size="md" />}
  </Avatar>
);
